import Proxy from '../Proxy';

class OrderComplexOptimizedProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('orders-complex-optimized', parameters);
  }
}

export default OrderComplexOptimizedProxy;
